import { Work } from '../types/interfaces'

export const works: Work[] = [
  {
    Name: 'Alfabit',
    Position: 'Специалист по ИТ-приложениям',
    HowLong: '12.2024 - настоящее время',
    Tasks: [
      'Программирование сетевых служб, приложений и веб-сайтов для клиентов и бизнеса.',
      'Внедрение беспроводных и облачных технологий (автоматизация).',
      'Администрирование серверов и управление API и базами данных. Устранение неполадок и техническая поддержка клиентов.',
    ],
  },
  {
    Name: 'Techgroup',
    Position: 'Техник связи',
    HowLong: '08.2025 - 09.2025',
    Tasks: [
      'Прокладка и монтаж оптоволоконных кабелей. Обслуживание и ремонт телекоммуникационных сетей.',
      'Настройка и обслуживание сетевых устройств и домашних интернет-сетей.',
      'Программирование сетевых сервисов и приложений.',
    ],
  },
  {
    Name: 'Национальный центр ядерных исследований',
    Position: 'Стажер в отделе ядерной аппаратуры',
    HowLong: '07.2025 - 08.2025',
    Tasks: [
      'Ознакомление с созданием, проверкой и валидацией технологической документации.',
      'Изучение основ программирования ПЛК-контроллеров Siemens и Beckhoff.',
      'Создание и тестирование программного обеспечения для ускорителя AQURE на языках программирования C++ и C#.',
      'Сборка и ввод в эксплуатацию электрических компонентов ускорителей. Проведение функциональных испытаний.',
    ],
  },
  {
    Name: 'Elepotrik',
    Position: 'Инженер в электронном сервисе',
    HowLong: '08.2024 - 09.2024',
    Tasks: [
      'Диагностика и ремонт электронных устройств, включая компьютерное и мобильное оборудование.',
      'Пайка и замена электронных компонентов. Работа с диагностическим оборудованием.',
      'Проведение функциональных тестов и ремонт программного обеспечения в устройствах.',
      'Прием заказов и общение с клиентами.',
    ],
  },
  {
    Name: 'Lewe Korki',
    Position: 'Основатель проекта, репетитор, full-stack разработчик',
    HowLong: '07.2023 - 05.2024',
    Tasks: [
      'Создание и поддержка образовательной платформы для репетиторов и организация занятий через нее.',
      'Управление базами данных — организация пользователей и учебных материалов.',
      'Репетиторство по физике и математике для старшеклассников.',
    ],
  },
  {
    Name: 'Soulgraphy',
    Position: 'Создатель и руководитель проекта, front-end разработчик',
    HowLong: '11.2020 - 07.2021',
    Tasks: [
      'Создание и развитие платформы для политических тестов, позволяющей анализировать взгляды пользователей.',
      'Управление командой из 20 человек, организация молодежных дебатов и интервью с политиками.',
      'Достижение десятков тысяч посещений ежедневно.',
      'Присутствие платформы в сети — тесты по-прежнему доступны на <a href="https://soulgraphy.me">Soulgraphy</a>.',
    ],
  },
]
